import React from 'react';
export function LinkRD({ children, item, onClick }) {
  const esLink =
    item.data.IdentificadorCuenta !== "Subtotal" &&
    item.data.IdentificadorCuenta !== "Total";

  return (
    <React.Fragment>
      <div
        className={esLink ? "link" : ""}
        onClick={() => {
          if (!esLink) return;
          onClick();
        }}
      >
        {children}
      </div>
    </React.Fragment>
  );
}
